// Cross-module read-projection shapes consumed by feed reads, recommendations,
// the SPA via @leanin/api-client generated types, and any other module that
// renders another module's content. The owning module's public.ts re-exports
// its own view types so cross-module callers import via the public contract.
/** Runtime narrowing for `AttachedEntityKind` → `AttachableInputKind`. Use at
 *  every write boundary (create-post submission, resolve-attachment call,
 *  draft rehydration) to drop stale Circle/Network entries gracefully — the
 *  server rejects them anyway, and silently filtering matches existing UX
 *  (anything no longer visible to the viewer is already dropped). */
export function isAttachableInputKind(kind) {
    return kind !== 'circle' && kind !== 'network';
}
/** Which dialect a post/comment `body` stores: 'v1' = legacy pseudo-markdown
 *  (global `**`/`*`/`__` splits), 'v2' = GFM-subset markdown from the TipTap
 *  composer. Renderers branch on it during the editor-rework rollout;
 *  transitional — removed once the v1→v2 backfill lands (PR C of
 *  docs/design/decisions/2026-08-04-post-editor-rework.md). */
export const BODY_FORMATS = ['v1', 'v2'];
//# sourceMappingURL=views.js.map